import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { ThankYouViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view-decorator';

export const LeaseDealsThankYouViewAsync = ThankYouViewDecorator(
  lazyLoad({
    loader: () => import(/* webpackChunkName: "lease-deals-thank-you-view" */ './lease-deals-thank-you-view'),
    componentName: 'LeaseDealsThankYouView',
  })
);
